import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './index.css';

import { toast } from 'react-toastify';
import {
  Box,
  Button, ButtonBase, Card, CardActions, CardContent, CardHeader, Dialog, DialogActions,
  DialogContent,
  DialogTitle, IconButton,
  TextField,
  Typography,
} from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { LoadingButton } from '@mui/lab';

import { SvgCloseFill, SvgWarningFill } from '../SvgIcons';
import { toggleMessageOverlay } from '../../store/actions/slices/messageAction';


// toast options
const options = {
  position: 'top-center',
  autoClose: 3000, // 2000
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: 'colored',
  closeButton: false,
  // transition: Slide
};


export const  toastSuccess = (title, position = "top-center", action) => {
  const toastContent = () => (
    <Typography
      px={1.5}
      py={1.375}
      width={'auto'}
      height={'auto'}
      variant={'body1'}
      display={'inline-flex'}
      alignItems={'center'}
      justifyContent={'center'}
      borderRadius={0}
      border={`1px solid rgba(165, 214, 255, 0.32)`}
      boxShadow={`0px 6px 15px 0px rgba(51, 51, 51, 0.15)`}
      sx={{
        backgroundColor: 'toast.background',
        color: 'toast.contrastText',
        textAlign: 'center',
        position: 'relative',
      }}
    >
      <svg style={{ marginRight: '8px' }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M6.99987 4.51677C8.47991 3.52784 10.22 3 12 3C14.387 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12C21 13.78 20.4722 15.5201 19.4832 17.0001C18.4943 18.4802 17.0887 19.6337 15.4442 20.3149C13.7996 20.9961 11.99 21.1743 10.2442 20.8271C8.49836 20.4798 6.89472 19.6226 5.63604 18.364C4.37737 17.1053 3.5202 15.5016 3.17294 13.7558C2.82567 12.01 3.0039 10.2004 3.68509 8.55585C4.36628 6.91131 5.51983 5.50571 6.99987 4.51677ZM9.932 15.746C10.1298 15.9241 10.3868 16.0221 10.653 16.021H10.654C10.9261 16.0219 11.1883 15.9189 11.387 15.733L16.687 10.733C16.7845 10.6431 16.8624 10.5342 16.9161 10.413C16.9697 10.2917 16.9979 10.1608 16.9988 10.0282C16.9998 9.89561 16.9734 9.76425 16.9215 9.64226C16.8696 9.52028 16.7932 9.41025 16.697 9.31901C16.4986 9.12957 16.2355 9.02295 15.9612 9.0209C15.6869 9.01886 15.4222 9.12155 15.221 9.30801L10.641 13.629L8.764 11.94C8.55943 11.7571 8.29291 11.6589 8.01858 11.6654C7.74424 11.6719 7.48267 11.7826 7.287 11.975C7.19283 12.0682 7.11874 12.1797 7.06929 12.3027C7.01983 12.4256 6.99606 12.5573 6.99943 12.6898C7.0028 12.8223 7.03325 12.9526 7.08889 13.0729C7.14454 13.1931 7.22421 13.3007 7.323 13.389L9.932 15.746Z" fill="#0BC50B"/>
      </svg>
      { title }
      { action }
    </Typography>
  );
  return toast(toastContent, { ...options, position })
};


export const toastError = (title, position = "top-center") => {
  const toastContent = () => (
    <Typography
      px={1.5}
      py={1.375}
      width={'auto'}
      height={'auto'}
      variant={'body1'}
      display={'inline-flex'}
      alignItems={'center'}
      justifyContent={'center'}
      borderRadius={0}
      border={`1px solid rgba(165, 214, 255, 0.32)`}
      boxShadow={`0px 6px 15px 0px rgba(51, 51, 51, 0.15)`}
      sx={{
        backgroundColor: 'error.main',
        color: 'common.white',
        textAlign: 'center',
        position: 'relative',
      }}
    >
      <svg style={{ marginRight: '8px' }} id="ic-24-error" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path id="Union_419" data-name="Union 419" d="M-1704,9646a9,9,0,0,1,9-9,9,9,0,0,1,9,9,9,9,0,0,1-9,9A9,9,0,0,1-1704,9646Zm2,0a7.008,7.008,0,0,0,7,7,7.008,7.008,0,0,0,7-7,7.009,7.009,0,0,0-7-7A7.009,7.009,0,0,0-1702,9646Zm9.043,3.455-2.043-2.042-2.043,2.042a.994.994,0,0,1-.708.293.994.994,0,0,1-.708-.293,1,1,0,0,1,0-1.413l2.043-2.043-2.043-2.042a1,1,0,0,1,0-1.415,1,1,0,0,1,1.415,0l2.043,2.043,2.043-2.043a1,1,0,0,1,1.415,0,1,1,0,0,1,0,1.415l-2.043,2.042,2.043,2.043a1,1,0,0,1,0,1.413,1,1,0,0,1-.708.293A.994.994,0,0,1-1692.957,9649.456Z" transform="translate(1707 -9634)" fill="#FFFFFF" stroke="rgba(255,36,36,0)" strokeMiterlimit="10" strokeWidth="2"/>
        <rect id="Rectangle_10124" data-name="Rectangle 10124" width="24" height="24" fill="none"/>
      </svg>
      { title }
    </Typography>
  );
  return toast(toastContent, { ...options, position })
};



// ===============================|| Waring Form Dialog ||=============================== //
export const WaringFormOverlay = ({ 
  primary, 
  children, onConfirm, confirmText, onCancel, cancelText, disabledConfirmButton, hiddenCancelButton,
  title,
  description,
  placeholder
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [value, setValue] = useState('');
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = async (values) => {
    
  };

  return (
    <>
      <Box onClick={() => handleOpen()}>{primary || children}</Box>
      <Dialog
        open={Boolean(open)}
        PaperProps={{
          sx: {
            overflow: 'visible',
            minWidth: 336,
            minHeight: 304,
            borderRadius: `4px`
          }
        }}
      >
        {
          title && (
            <DialogTitle sx={{ fontSize: 20, fontWeight: 700, py: 1.5, px: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              { title || '標題' }
              <IconButton
                aria-label="close"
                onClick={() => {
                  handleClose();
                  onCancel?.();
                }}
              >
                <SvgCloseFill color='text.primary'size={18} />
              </IconButton>
            </DialogTitle>
          )
        }

        <DialogContent sx={{ p: 0 }} />
        <DialogContent sx={{ px: 3, py: 2, borderTop: `1px solid ${theme.palette.divider}`, borderBottom: `1px solid ${theme.palette.divider}` }}>
          <Typography variant={'body1'}>{ description }</Typography>
          <Box position={'relative'} mt={2}>
            <TextField
              fullWidth
              multiline
              rows={4}
              maxLength={150}
              onInput={(event) => setValue(event.target.value)}
              inputProps={{ maxLength: 150 }}
              placeholder={placeholder}
              InputProps={{
                sx: {
                  borderRadius: '4px',
                  padding: '8px',
                }
              }}
            />
            <Box
              direction={'row'}
              alignItems={'center'}
              position={'absolute'}
              right={8}
              top={84}
            >
              <Typography variant='body2' color={value && (Number(value?.length >= 0) ) ? 'color.secondaryMain' : 'text.secondary'}>
                {value ? value?.length : 0}/150 
              </Typography>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2, gap: 0.5 }}>
          {
            !hiddenCancelButton && (
              <Button
                size='large'
                variant={'outlined'} 
                color={'inherit'}
                sx={{ maxHeight: 40 }}
                onClick={() => {
                  handleClose();
                  onCancel?.();
                }}
              >
                {cancelText || '取消'}
              </Button>
            )
          }
          {/* ...theme.typography.h6 */}
          <Button  
            onClick={() => {
              handleClose();
              onConfirm?.(value)
            }} 
            variant={'contained'} 
            color={'primary'} 
            size={'large'}
            disabled={(value?.length <= 0) || disabledConfirmButton}
            sx={{ whiteSpace: 'nowrap', maxHeight: 40, }}
          >
            {confirmText || '確定'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
};


export const MessageOverlay = ({ children }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { message } = useSelector(state => state?.slices);
  const { open, title, content, cancelText, confirmText, hiddenCancelButton, disabledConfirmButton, onCancel, onConfirm } = message || {};

  return (
    <>
      { children }
      <Dialog
        open={Boolean(open)}
        PaperProps={{
          sx: {
            overflow: 'visible',
            maxWidth: 336,
            borderRadius: `4px`
          }
        }}
      >
        {
          title && (
            <DialogTitle sx={{ fontSize: 20, fontWeight: 700, py: 1.5, px: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              { title || '標題' }
              <IconButton
                aria-label="close"
                onClick={() => onCancel?.() || dispatch(toggleMessageOverlay({ open: false }))}
              >
                <SvgCloseFill color='text.primary'size={18} />
              </IconButton>
            </DialogTitle>
          )
        }

        <DialogContent sx={{ p: 0 }} />
        <DialogContent sx={{ px: 3, py: 2, borderTop: `1px solid ${theme.palette.divider}`, borderBottom: `1px solid ${theme.palette.divider}` }}>
          <Typography variant={'body1'}>{ content }</Typography>
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2 }}>
          {
            !hiddenCancelButton && (
              <Button
                size='large'
                variant={'outlined'} 
                color={'inherit'}
                sx={{ maxHeight: 40 }}
                onClick={() => onCancel && onCancel()}
              >
                {cancelText || '取消'}
              </Button>
            )
          }
          {/* ...theme.typography.h6 */}
          <Button  
            onClick={() => onConfirm && onConfirm()} 
            variant={'contained'} 
            color={'primary'} 
            size={'large'}
            disabled={disabledConfirmButton}
            sx={{ whiteSpace: 'nowrap', maxHeight: 40 }}
          >
            {confirmText || '確定'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
};



export const SnackbarWaring = ({ open, title, description, backText, nextText = '下一步', onBack, onNext, pagination, sx, arrowSx }) => {
  const theme = useTheme();
  return open && (
    <Card
      onClick={(event) => {
        event.stopPropagation();
        event.preventDefault();
      }}
      sx={{
        overflow: 'visible',
        borderRadius: '6px',
        padding: '16px',
        pointerEvents: 'all',
        position: 'absolute',
        boxShadow: '0px 2px 10px 0px rgba(157, 172, 208, 0.40)',
        ...sx,
        '&:before': {
          content: '""',
          width: 0,
          height: 0,
          display: 'block',
          borderLeft: '10px solid transparent',
          borderRight: '10px solid transparent',
          borderTop: '10px solid transparent',
          position: 'absolute',
          top: -16,
          left: 35,
          zIndex: 1,
          ...arrowSx,
        }
      }}
      elevation={5}
    >
      <CardHeader
        disableTypography
        sx={{
          p: 0,
          textAlign: 'left',
        }}
        title={
          <Box position={'relative'} pl={3.25} display={'flex'} alignItems={'center'}>
            <SvgWarningFill
              style={{
                position: 'absolute',
                left: '0px'
              }}
            />
            <Box width={'100%'} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
              <Typography variant={'body1'} fontWeight={700}>{ title }</Typography>
              <Typography variant={'body2'} color={'secondary.main'}>{ pagination }</Typography>
            </Box>
          </Box>
        }
      />

      {
        description && (
          <CardContent
            sx={{
              p: 0,
              mt: 1.25,
              mb: 1.75,
              textAlign: 'left'
            }}
          >
            <Box pl={3.25}>
              <Typography variant={'body1'} color={'#FFFFFF'}>{ description }</Typography>
            </Box>
          </CardContent>
        )
      }
      
      <CardActions
        sx={{
          p: 0,
          mt: 2,
          ml: 3.25,
        }}
      >
        <ButtonBase
          disableRipple
          onClick={onBack}
          size='small'
          sx={{
            ...theme.typography.h6,
            color: theme.palette.common.white,
            flex: 1,
            px: 2,
            py: 0.75,
          }}
        >
          { backText }
        </ButtonBase>
        <Button
          disableRipple
          disableElevation
          color='primary'
          variant='contained'
          size='small'
          onClick={onNext}
          sx={{
            fontSize: 16,
            fontWeight: 700,
            pt: 0.25,
            pb: 0.375,
            minWidth: 0,
          }}
        >
          { nextText }
        </Button>

        <Box position={'absolute'} bottom={-10} left={`74%`}>
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8" fill="none">
            <path d="M5 8L0 2L10 2L5 8Z" fill="#FDFDFD"/>
            <path d="M5 6.5L0 0.5L10 0.500001L5 6.5Z" fill="#FDFDFD"/>
          </svg>
        </Box>
      </CardActions>
    </Card>
  )
};